// KyckSocial — which location the club is acting as, across pages.
//
// ⚠️⚠️ WHY THIS EXISTS: the three KyckSocial pages are now left-nav destinations,
// and a nav link is a static path, so it cannot carry `?account=`. Without a
// memory, picking location B on Posts and clicking Inbox would silently land in
// location A's inbox — and a reply sent there goes out as the wrong club. That is
// not a reset, it is a wrong-club action.
//
// ONE shared key, not one per page: the whole point is that a choice made on one
// page is still true on the next. The remembered id is only a SEED: it is checked
// against the options the server gave us exactly as a URL value is, and an id that
// is not among them falls back to the first location rather than being sent.

const KEY = 'kyck-portal-social-account';

export function resolveSocialAccount(
  requested: string | null,
  remembered: string | null,
  optionIds: readonly string[],
): string | null {
  if (requested && optionIds.includes(requested)) return requested;
  if (remembered && optionIds.includes(remembered)) return remembered;
  return optionIds[0] ?? null;
}

// Every storage access is try/caught: some privacy modes throw, and a page that
// white-screens because it could not remember a dropdown is the wrong trade.
export function loadRememberedSocialAccount(): string | null {
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberSocialAccount(id: string): void {
  try {
    window.sessionStorage.setItem(KEY, id);
  } catch {
    /* not remembered; the URL still carries it */
  }
}
